export enum GROUPING_TYPE {
  BY_CONTRACT = 'BY_CONTRACT',
  BY_ORGANIZATION = 'BY_ORGANIZATION',
}

export enum WDH_GROUPING_TYPE {
  WDH_BY_CONTRACT = 'Regroupement Entreprises',
  WDH_BY_ORGANIZATION = 'Regroupement Organisations',
}

export enum GROUPING_FAMILY {
  INTERNAL = 'INTERNAL',
  CLIENT = 'CLIENT',
}

export enum WHD_GROUPING_FAMILY {
  WHD_INTERNAL = 'Regroupement Interne',
  WHD_CLIENT = 'Regroupement Client',
  WHD_GCN = 'GCN',
  WHD_PORTFEUILLE = 'Portefeuille Commercial',
}

export enum ORGANIZATION_STATUT {
  STATUT_ACTIF = 'Actif',
  STATUT_ENCREATION = 'EnCreation',
  STATUT_INACTIF = 'Inactif',
  STATUT_SUPPRIME = 'Supprime',
}

export enum ACTION_TYPE {
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
}
